@if (substitutions) {
  <div class="flex-fill d-flex flex-column dx-card">
    <div class="flex-fill d-flex flex-column dx-card">
      <div class="d-flex flex-column flex-fill responsive-paddings">
        <dx-data-grid
          #substitutionsDataGrid
          keyExpr="id"
          class="flex-fill d-flex flex-column"
          [dataSource]="substitutions"
          height="100px"
          [showBorders]="true"
          [showRowLines]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          >
          <dxi-data-grid-column dataField="id" caption="Job #" width="70" cellTemplate="rentalLinkTemplate"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="rentalId" caption="Rental #" width="70" cellTemplate="rentalLinkTemplate"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="companyName" width="240"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="name" caption="Customer Name" width="120"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="action" width="85"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="size" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="billAs" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="completed" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="siteName" width="190"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="address1" width="215"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="address2" width="160"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="city" width="125"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="state" width="50"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="zip" width="60"></dxi-data-grid-column>
          <dxi-data-grid-column></dxi-data-grid-column>
          <div *dxTemplate="let cell of 'rentalLinkTemplate'">
            @if (cell) {
              <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
            }
          </div>
          <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
          <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
          <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="substitutions-grid"></dxo-data-grid-state-storing>
          <div *dxTemplate="let data of 'toolbarButtons'"></div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (substitutions) {
              <span class="me-3">
                <strong>{{ substitutionsDataGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    </div>
  </div>
}
